<template>
  <div class="section-title">
    <div class="s-subtitle theme-after dark-color">
      <slot name="p-1"/>
    </div>
    <div class="st-title">
      <div class="s-title theme-after dark-color">
        <slot name="p-2"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Title100",
}
</script>

<style scoped>
.section-title {
  margin: 0 0 40px;
}

.section-title .s-subtitle {
  display: inline-block;
  vertical-align: top;
  position: relative;
  z-index: 1;
  padding: 3px 10px;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 11px;
  margin: 0 0 8px;
  text-transform: uppercase;
}

.section-title .s-subtitle:after {
  top: 0;
  bottom: 0;
  left: 0;
  right: 10px;
  position: absolute;
  content: "";
  z-index: -1;
  transform: skew(-20deg);
  -webkit-transform: skew(-20deg);
}

.section-title .s-title {
  font-size: 45px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  border-bottom: 1px solid #ddd;
  display: inline-block;
  vertical-align: top;
  padding: 0 0 10px;
  text-transform: uppercase;
  margin: 0;
}

.section-title .s-title:after {
  height: 8px;
  width: 50px;
  bottom: -4px;
  left: 0;
  right: 0;
  position: absolute;
  content: "";
  z-index: -1;
  transform: skew(-36deg);
  -webkit-transform: skew(-36deg);
}

.sub-title .s-title {
  display: inline-block;
  position: relative;
  vertical-align: top;
  font-weight: 600;
  font-size: 22px;
  text-transform: uppercase;
  margin: 0;
  padding: 0 0 10px;
}

.sub-title .s-title:after {
  height: 4px;
  width: 50px;
  bottom: -2px;
  left: 0;
  right: 0;
  position: absolute;
  content: "";
  z-index: 1;
  transform: skew(-36deg);
  -webkit-transform: skew(-36deg);
}

@media (max-width: 1200px) {
  .section-title .s-subtitle {
    padding: 3px 8px;
    letter-spacing: 2px;
    font-size: 10px;
  }

  .section-title .s-title {
    font-size: 35px;
  }
}

@media (max-width: 991px) {
  .section-title .s-title {
    font-size: 30px;
  }

  .section-title {
    margin: 0 0 30px;
  }
}

.theme-after:after {
  background: var(--secondary);
}
</style>